import { HttpError } from "react-admin";

import { createApiClient } from "@/api";
import { HTTP_STATUS } from "@/constants/http";
import { type DataProviderSchema } from "@/utils";
import { getLocalFilteredSortedList } from "@/utils/listParams";

const apiClient = createApiClient("json");
const BASE_URL = "/api/vpn/traffic_sources";

const fetchListData = async () => {
  const { data = [] } = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });

  return {
    data,
    total: data.length,
  };
};

export const trafficSourcesSchema: DataProviderSchema<"TrafficSource", "json"> =
  {
    list: getLocalFilteredSortedList(fetchListData),
    detail: async ({ id }) => {
      const { data } = await apiClient.GET(`${BASE_URL}/{id}`, {
        params: {
          path: { id: String(id) },
        },
      });

      if (!data) throw new Error("Traffic Source not found");

      return { data };
    },
    edit: async ({ id, data: { title, maxClickIdLength } }) => {
      if (!title) throw Error("Title is required");
      const { data } = await apiClient.PUT(`${BASE_URL}/{id}`, {
        params: {
          path: { id: String(id) },
        },
        body: {
          title,
          maxClickIdLength,
        },
      });

      if (!data) throw Error("Something went wrong");

      return { data };
    },
    create: async ({ data: { title, maxClickIdLength } }) => {
      if (!title) throw Error("Title is required");
      const { data } = await apiClient.POST(BASE_URL, {
        body: {
          title,
          maxClickIdLength,
        },
      });

      if (!data)
        throw new HttpError(
          "Something went wrong!",
          HTTP_STATUS.INTERNAL_SERVER_ERROR,
        );

      return {
        data,
      };
    },
  };
